"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultReminderTemplate = void 0;
const locales_1 = require("../internationalization/enums/locales");
const auction_reminder_en_1 = require("./auction-reminder.en");
const auction_reminder_fr_1 = require("./auction-reminder.fr");
const event_reminder_en_1 = require("./event-reminder.en");
const event_reminder_fr_1 = require("./event-reminder.fr");
const getDefaultReminderTemplate = ({ isAuction, locale, }) => {
    // eslint-disable-next-line zeffy-linter/no-locale-condition
    const isFrench = locale === locales_1.Locales.FR;
    if (isAuction) {
        return isFrench ? auction_reminder_fr_1.auctionReminderTemplateFr : auction_reminder_en_1.auctionReminderTemplateEn;
    }
    return isFrench ? event_reminder_fr_1.eventReminderTemplateFr : event_reminder_en_1.eventReminderTemplateEn;
};
exports.getDefaultReminderTemplate = getDefaultReminderTemplate;
